import { useNavigate } from 'react-router-dom';
import type { RecommendedCarousel } from '../../../types';
import BlurFillImage from './BlurFillImage';

interface CarouselProps {
  carousel: RecommendedCarousel;
}

const CarouselItem = ({
  item,
  onClick,
}: {
  item: RecommendedCarousel['items'][0];
  onClick: () => void;
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        width: '140px',
        flexShrink: 0,
        cursor: 'pointer',
      }}
    >
      <BlurFillImage
        imageUrl={item.imageUrl}
        style={{
          width: '140px',
          height: '140px',
          borderRadius: '8px',
          marginBottom: '8px',
        }}
      />
      <p
        style={{
          margin: 0,
          fontSize: '0.9rem',
          fontWeight: 500,
          color: 'var(--primary)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          lineHeight: 1.3,
        }}
      >
        {item.title}
      </p>
    </div>
  );
};

export default function Carousel({ carousel }: CarouselProps) {
  const navigate = useNavigate();

  if (carousel.items.length === 0) return null;

  return (
    <div>
      {/* Header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          margin: '0 10px 12px 10px',
        }}
      >
        <h2
          onClick={() => carousel.link && navigate(carousel.link)}
          style={{
            margin: 0,
            fontSize: '1.25rem',
            fontFamily: 'var(--font-display)',
            fontWeight: 400,
            color: 'var(--primary)',
            cursor: carousel.link ? 'pointer' : 'default',
          }}
        >
          {carousel.title}
        </h2>
        {carousel.link && (
          <button
            onClick={() => navigate(carousel.link!)}
            className="text-link"
            style={{ fontSize: '0.85rem', padding: 0 }}
          >
            See all
          </button>
        )}
      </div>

      {/* Scrollable items */}
      <div
        style={{
          display: 'flex',
          gap: '12px',
          overflowX: 'auto',
          padding: '0 10px 8px 10px',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        {carousel.items.map((item) => (
          <CarouselItem
            key={item.id}
            item={item}
            onClick={() => navigate(`/id/${item.id}`)}
          />
        ))}
      </div>
    </div>
  );
}
